import { render, staticRenderFns } from "./VmSelect.vue?vue&type=template&id=3069f61e&scoped=true&"
import script from "./VmSelect.vue?vue&type=script&lang=js&"
export * from "./VmSelect.vue?vue&type=script&lang=js&"
import style0 from "./VmSelect.vue?vue&type=style&index=0&id=3069f61e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3069f61e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
